/**
 * Cart Address Main
 * Orchestrates all cart address functionality
 */

(function() {
  'use strict';


  async function init() {
    const container = document.getElementById('cart-address');
    if (!container) return;

    console.log('✅ cart-address initialized');


    // Add validation styles
    if (!document.getElementById('cart-address-styles')) {
      const style = document.createElement('style');
      style.id = 'cart-address-styles';
      style.textContent = `
        #cart-address input.cart-address-error {
          border-color: #d32f2f !important;
          background-color: #ffebee !important;
        }
        #cart-address input:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          background-color: #f5f5f5;
          transition: all 0.3s ease;
        }
        #cart-address input:disabled::placeholder {
          color: #999;
        }
      `;
      document.head.appendChild(style);
    }


    // Ensure data maps are accessible
    const validation = window.CartAddressValidation;
    const sync = window.CartAddressSync;

    const entryInput = container.querySelector('[data-prop="Entry"]');
    const floorInput = container.querySelector('[data-prop="Floor"]');

    // Prefill from cart
    sync.prefill(container);

    // Setup save handlers
    container.querySelectorAll('[data-prop]').forEach(input => {
      input.addEventListener(input.type === 'radio' ? 'change' : 'input', () => {
        sync.save(container, validation);
      });
    });

    // Elevator radio button handlers
    const elevatorOptions = container.querySelectorAll('.cart-elevator-option');
    elevatorOptions.forEach(option => {
      const radio = option.querySelector('input[type="radio"]');
      const text = option.querySelector('.cart-elevator-option-text');
      
      if (radio && text) {
        text.addEventListener('click', (e) => {
          e.preventDefault();
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('input', { bubbles: true }));
        });
        
        option.addEventListener('click', (e) => {
          if (e.target === option) {
            e.preventDefault();
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            radio.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });
      }
    });

    // Form submission validation
    const cartForm = document.querySelector('form[action^="/cart"]');
    if (cartForm) {
      cartForm.addEventListener('submit', (e) => {
        if (!validation.validateAll(container, true)) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    }

    // Checkout button validation
    const checkoutButtons = document.querySelectorAll('.btn-checkout, [name="checkout"], .wt-cart__cta[name="checkout"]');
    checkoutButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        if (button.type === 'button' || button.onclick) {
          if (!validation.validateAll(container, true)) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }
      });
    });

    // Intercept checkout form submissions
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (form && (form.action && form.action.includes('/cart') || form.querySelector('[name="checkout"]'))) {
        const checkoutButton = form.querySelector('[name="checkout"]');
        if (checkoutButton && !validation.validateAll(container, true)) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    }, true);


    // Setup mutation observer for syncing to new items
    const cartRoot =
      document.querySelector('form[action^="/cart"]') ||
      document.querySelector('.cart') ||
      document.body;

    const observer = new MutationObserver(() => {
      sync.syncToNewItems();
    });

    observer.observe(cartRoot, {
      childList: true,
      subtree: true
    });

    sync.syncToNewItems();
  }

  // Support both DOMContentLoaded and immediate execution
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
